import axios from "axios";



const api = axios.create({
    baseURL: process.env.REACT_APP_BASE_URL,
});

export const getWithToken = async (url, params = {}) => {
    try {
        const token = localStorage.getItem("token");

        const response = await api.get(url, {
            params, // Parameter tambahan untuk query
            headers: { Authorization: `Bearer ${token}` }, // Pin di headers
        });
        return response.data;
    } catch (error) {
        if (error.response?.status === 401) {
            localStorage.removeItem("token");
            window.location.href = "/auth";
        }
        return Promise.reject(error);
    }
};

export const postWithToken = async (url, body = {}) => {
    try {
        const token = localStorage.getItem("token");

        const response = await api.post(url, body, { // body langsung di sini
            headers: {
                Authorization: `Bearer ${token}` // Headers di tempat yang benar
            }
        });
        return response.data;
    } catch (error) {
        if (error.response?.status === 401) {
            localStorage.removeItem("token");
            // window.location.href = "/auth"; 
        }
        return Promise.reject(error);
    }
};

export default api;